export { default as DetailCategory } from "./DetailInfo/DetailCategory";
export { default as DetailCategoryUpsert } from "./DetailInfo/DetailCategoryUpsert";
export { default as DetailContents } from "./DetailInfo/DetailContents";
export { default as DetailInfoList } from "./DetailInfo/DetailInfoList";
export { default as DetailInfoListUpsert } from "./DetailInfo/DetailInfoListUpsert";

export { default as Home } from "./Home/Home";
export { default as HomeUpdate } from "./Home/HomeUpdate";

export { default as Login } from "./Login/Login";

export { default as ProductIntroduceList } from "./ProductIntroduce/ProductIntroduceList";
export { default as ProductUpsert } from "./ProductIntroduce/ProductUpsert";

export { default as ReelsCategory } from "./Reels/ReelsCategory";
export { default as ReelsCategoryUpsert } from "./Reels/ReelsCategoryUpsert";
export { default as ReelsList } from "./Reels/ReelsList";
export { default as ReelsUpsert } from "./Reels/ReelsUpsert";

export const INSERT_TAG = "1742272647335";
